import RenderActivities from "./RenderActivities";
export default RenderActivities;
